import { Formik } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import { Button, Form } from 'react-bootstrap';
import * as yup from 'yup';

import PasswordFormControl from '../../../lib/Form/PasswordFormControl';
import CustomModal from '../CustomModal';

const schema = yup.object().shape({
  password: yup.string().required('Password is required'),
});

const JoinNetwork = ({ network, modal, onJoin, onHide }) => {
  return (
    <CustomModal modal={modal} onHide={onHide} size="md">
      <CustomModal.Header onHide={onHide}>
        The network &ldquo;{network.ssid}&rdquo; requires a password
      </CustomModal.Header>
      <Formik
        validationSchema={schema}
        onSubmit={({ password }) => {
          onJoin({
            ...network,
            passphrase: password,
          });
        }}
        initialValues={{
          password: '',
        }}
      >
        {(formik) => (
          <Form noValidate onSubmit={formik.handleSubmit}>
            <CustomModal.Body>
              <PasswordFormControl
                name="password"
                groupClassName="padded-control"
                label="Password"
              />
            </CustomModal.Body>

            <CustomModal.Footer>
              <Button
                variant="link"
                className="text-capitalize"
                onClick={() => onHide(false)}
              >
                Cancel
              </Button>
              <Button type="submit">Join</Button>
            </CustomModal.Footer>
          </Form>
        )}
      </Formik>
    </CustomModal>
  );
};
const networkShape = {
  ssid: PropTypes.string.isRequired,
  connected: PropTypes.bool.isRequired,
  security: PropTypes.string.isRequired,
  signalStrengthNormalized: PropTypes.number.isRequired,
};
const joinNetworkProps = {
  modal: PropTypes.bool.isRequired,
  network: PropTypes.shape(networkShape).isRequired,
  onHide: PropTypes.func.isRequired,
  onJoin: PropTypes.func.isRequired,
};
JoinNetwork.propTypes = joinNetworkProps;

const Warning = ({ network, modal, onHide, protectedSecurityModes }) => {
  return (
    <CustomModal modal={modal} onHide={onHide} size="md">
      <CustomModal.Header onHide={onHide}>Error</CustomModal.Header>
      <CustomModal.Body>
        <div>
          The network <strong>{network.ssid}</strong> uses an unsupported
          authentication method. Only passphrase authentication is supported.
        </div>
        <div className="mt-2">
          You can add network with only{' '}
          <strong>{protectedSecurityModes.toString()}</strong> security.
        </div>
      </CustomModal.Body>

      <CustomModal.Footer>
        <Button onClick={() => onHide(false)}>Ok</Button>
      </CustomModal.Footer>
    </CustomModal>
  );
};

Warning.propTypes = {
  modal: PropTypes.bool.isRequired,
  network: PropTypes.shape(networkShape).isRequired,
  onHide: PropTypes.func.isRequired,
  protectedSecurityModes: PropTypes.arrayOf(PropTypes.string),
};

const JoinNetworkModal = ({
  network,
  modal,
  onJoin,
  onHide,
  securityModes,
}) => {
  const protectedSecurityModes = securityModes.reduce((result, mode) => {
    if (mode.requiresPassphrase) {
      result.push(mode.name.toUpperCase());
    }
    return result;
  }, []);

  if (protectedSecurityModes.includes(network?.security)) {
    return (
      <JoinNetwork
        network={network}
        modal={modal}
        onJoin={onJoin}
        onHide={onHide}
      />
    );
  }

  return (
    <Warning
      network={network}
      modal={modal}
      onHide={onHide}
      protectedSecurityModes={protectedSecurityModes}
    />
  );
};

JoinNetworkModal.propTypes = {
  ...joinNetworkProps,
  securityModes: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      requiresPassphrase: PropTypes.bool.isRequired,
    }),
  ).isRequired,
};
export default JoinNetworkModal;
